import {
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGOUT_SUCCESS,
} from "./actions";

const initialState = {
  requesting: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        requesting: true,
        authData: undefined,
      };

    case LOGIN_SUCCESS:
      return {
        requesting: false,
        authData: action.authData,
      };

    case LOGIN_ERROR:
      return {
        requesting: false,
        authData: undefined,
      };

    case LOGOUT_SUCCESS:
      return {
        requesting: false,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/pages/login/reducer.js